export const PRICE_TICKET_REQUEST = 'PRICET_TICKET_REQUEST';
export const PRICE_TICKET_REQUEST_ABORT = 'PRICE_TICKET_REQUEST_ABORT';

export const PORT_TAXES = 'PORT_TAXES';
export const TOURISTIC_TAXES = 'TOURISTIC_TAXES';
